<div class="container-navbar w-full max-w-[1272px] mx-auto px-3">
  <div class="w-full banner">
    <a class="bold" routerLink="/refund-policy"><u>See Improvement in 14 Days or Your Money
    Back</u></a>&nbsp;|&nbsp;
    <a class="bold" routerLink="/store/product/weighted-vest"><u>BUY NOW</u></a>&nbsp;
    <small>(free shipping)</small>&nbsp;
  </div>
  <div class="navbar h-[50px] lg:h-[60px] flex flex-row items-center justify-between p-4">
    <div class="logo">
      <a routerLink="/"><xos-company-logo [height]="47"></xos-company-logo></a>
    </div>
    <div class="flex-row menu-items gap-[30px] hidden lg:flex">
      @for (menuItem of menuItems; track menuItem) {
        @if (!menuItem.isExternal) {
          <a class="menu-item"
            [ngClass]="{'active': menuItem.route === currentRoute}" [routerLink]="menuItem.route">
            {{ menuItem.name }}
          </a>
        }
        @if (menuItem.isExternal) {
          <a class="menu-item" [ngClass]="{'active': menuItem.route === currentRoute}"
            [href]="menuItem.route">
            {{ menuItem.name }}
          </a>
        }
      }
    </div>
    <div class="flex flex-row gap-[20px] items-center">
      <xos-button class="hidden lg:block" (click)="goToStore()" [appearance]="'secondary'"
      size="sm">Login</xos-button>
      <xos-button class="block lg:hidden" [appearance]="'icon'" (click)="openSidebar()" icon="menu-2"
      size="sm"></xos-button>
    </div>
  </div>
</div>